import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "fw-normal" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "col-5" }
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-3" }
const _hoisted_10 = { class: "col-5" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "col-3" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-save me-8",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_v_form_group_input_text = _resolveComponent("v-form-group-input-text")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form_group_select = _resolveComponent("v-form-group-select")!
  const _component_v_form_group_input_date = _resolveComponent("v-form-group-input-date")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_the_professional_patient_address_fieldset = _resolveComponent("the-professional-patient-address-fieldset")!
  const _component_modal_body = _resolveComponent("modal-body")!
  const _component_modal_footer = _resolveComponent("modal-footer")!
  const _component_v_modal = _resolveComponent("v-modal")!

  return (_openBlock(), _createBlock(_component_v_modal, {
    size: "xl",
    "class-name": "modal-fullscreen-lg-down",
    onKeypress: _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (_ctx.meta.valid ? _ctx.onSubmit() : null), ["prevent"]), ["enter"]))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_modal_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_modal_title, { as: "h4" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('Editar')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('datos personales')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_modal_body, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("fieldset", _hoisted_3, [
              _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Información personal')), 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_v_form_group_input_text, {
                    value: _ctx.name,
                    label: _ctx.$t('Nombre'),
                    class: "mb-24",
                    "yup-errors-variable": _ctx.errors.name,
                    autocomplete: "off",
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.name = $event))
                  }, null, 8, ["value", "label", "yup-errors-variable"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_v_form_group_input_text, {
                    value: _ctx.surname,
                    label: _ctx.$t('Apellidos'),
                    class: "mb-24",
                    "yup-errors-variable": _ctx.errors.surname,
                    autocomplete: "off",
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.surname = $event))
                  }, null, 8, ["value", "label", "yup-errors-variable"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_v_form_group_select, {
                    label: _ctx.$t('Género'),
                    class: "mb-24",
                    "yup-errors-variable": _ctx.errors.genre
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        class: _normalizeClass({'is-invalid': !!_ctx.errors.genre}),
                        options: _ctx.formsSettings.accepted_genre_options,
                        reduce: returnValue => returnValue.key,
                        "select-on-key-codes": [188, 13],
                        clearable: false,
                        modelValue: _ctx.genre,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.genre) = $event))
                      }, {
                        "no-options": _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                        ]),
                        _: 1
                      }, 8, ["class", "options", "reduce", "modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label", "yup-errors-variable"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_v_form_group_select, {
                    label: _ctx.$t('Tipo de documento'),
                    class: "mb-24",
                    "yup-errors-variable": _ctx.errors.identityDocType
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        class: _normalizeClass({'is-invalid': !!_ctx.errors.identityDocType}),
                        options: _ctx.formsSettings.accepted_identification_document_types,
                        reduce: returnValue => returnValue.key,
                        "select-on-key-codes": [188, 13],
                        clearable: false,
                        modelValue: _ctx.identityDocType,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.identityDocType) = $event))
                      }, {
                        "no-options": _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                        ]),
                        _: 1
                      }, 8, ["class", "options", "reduce", "modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label", "yup-errors-variable"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_v_form_group_input_text, {
                    label: _ctx.$t('Nº documento de identidad'),
                    value: _ctx.nif,
                    class: "mb-24",
                    "yup-errors-variable": _ctx.errors.nif,
                    autocomplete: "off",
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.nif = $event))
                  }, null, 8, ["label", "value", "yup-errors-variable"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_v_form_group_input_date, {
                    label: _ctx.$t('Fecha de nacimiento'),
                    value: _ctx.bornDate,
                    class: "mb-24",
                    "yup-errors-variable": _ctx.errors.bornDate,
                    autocomplete: "off",
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.bornDate = $event))
                  }, null, 8, ["label", "value", "yup-errors-variable"])
                ])
              ])
            ]),
            _createElementVNode("fieldset", _hoisted_12, [
              _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Contacto')), 1),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_v_form_group_input_text, {
                    type: "email",
                    value: _ctx.patient.user.email,
                    label: _ctx.$t('Correo electrónico'),
                    class: "mb-24",
                    autocomplete: "off",
                    disabled: true
                  }, null, 8, ["value", "label"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_v_form_group_select, {
                    label: _ctx.$t('Prefijo tel.'),
                    class: "mb-24",
                    "yup-errors-variable": _ctx.errors.phoneNumberPrefix
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        class: _normalizeClass({'is-invalid': !!_ctx.errors.phoneNumberPrefix}),
                        options: _ctx.formsSettings.valid_phone_number_prefix_options,
                        reduce: returnValue => returnValue.key,
                        "select-on-key-codes": [188, 13],
                        modelValue: _ctx.phoneNumberPrefix,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.phoneNumberPrefix) = $event))
                      }, {
                        "no-options": _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                        ]),
                        _: 1
                      }, 8, ["class", "options", "reduce", "modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label", "yup-errors-variable"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_v_form_group_input_text, {
                    value: _ctx.phoneNumber,
                    label: _ctx.$t('Teléfono'),
                    class: "mb-24",
                    "yup-errors-variable": _ctx.errors.phoneNumber,
                    autocomplete: "off",
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.phoneNumber = $event))
                  }, null, 8, ["value", "label", "yup-errors-variable"])
                ])
              ]),
              (_ctx.can('professional.patient.update'))
                ? (_openBlock(), _createBlock(_component_v_button, {
                    key: 0,
                    variant: "secondary",
                    "aria-label": _ctx.$t('Guardar cambios'),
                    disabled: !_ctx.meta.valid,
                    "is-loading": _ctx.accepted,
                    onClick: _ctx.onSubmit
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Guardar cambios')), 1)
                    ]),
                    _: 1
                  }, 8, ["aria-label", "disabled", "is-loading", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_the_professional_patient_address_fieldset, {
              type: "billing",
              "address-object": _ctx.billingAddress,
              onAddressUpdated: _ctx.handleAddressUpdatedEvent
            }, null, 8, ["address-object", "onAddressUpdated"]),
            _createVNode(_component_the_professional_patient_address_fieldset, {
              type: "shipping",
              "address-object": _ctx.shippingAddress,
              onAddressUpdated: _ctx.handleAddressUpdatedEvent
            }, null, 8, ["address-object", "onAddressUpdated"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_modal_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_button, {
            variant: "link-secondary",
            class: "me-24",
            "aria-label": _ctx.$t('Cerrar'),
            "data-bs-dismiss": "modal"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Cerrar')), 1)
            ]),
            _: 1
          }, 8, ["aria-label"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}